module.exports = "//static.hsappstatic.net/LoginUI/static-1.16087/img/openai-logo-black.svg"